export default __webpack_public_path__ + "static/media/tolerance.aae29920.svg";